<template>
  <div class="contract-information-page pb60" v-if="formData" v-loading.fullscreen.lock="fullscreenLoading">
    <Title currentPageTitle="开票审批详情"></Title>
    <!-- 申请信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">申请信息</p>
      <div class="contract-apply-box">
        <div class="contract-apply-item"><span>开票主体：</span>{{ formData.servicerTenantName }}</div>
        <div class="contract-apply-item"><span>开票金额(元)：</span>{{ formData.invoiceAmount | numDigit }}
          <span> &nbsp;&nbsp; &nbsp;&nbsp;大写：</span>{{ formData.invoiceAmount | upDigit }}
        </div>
        <!-- <div class="contract-apply-item"><span>月份：</span>{{ formData.month }}</div> -->
      </div>
      <img
        v-show="formData.approveVO && formData.approveVO.approveState !== 'N'"
        class="approve-img"
        :src="getApproveImg()"
        alt=""
      />
      <img  v-if="formData.isHedge=='Y'"  class="duichong-img" src="../../assets/images/ic_duichong.png" alt="" srcset="">
    </div>
    <div class="contract-base-box">
      <p class="contract-base-name">需开票的付款通知书信息</p>
      <div class="back-color-fff content-main-box" style="height: 100%" max-height="50vh">
        <el-table :data="formData.paymentTicketList" stripe border style="width: 100%" >
          <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
            fixed="left"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="100"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-'}}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="100"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="任务金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.taskSumAmount | numFmt | numDigit  }}</template>
          </el-table-column>
          <el-table-column
            prop="serviceFeeRate"
            label="服务费率"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="100"
          >
            <template slot-scope="scope">{{ (scope.row.serviceFeeRate || 0) + '%' }}</template>
          </el-table-column>
          <el-table-column
            prop="serviceFee"
            label="服务费(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.serviceFee | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="审批通过时间"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="100"
          >
            <template slot-scope="scope">{{ scope.row.approveTime | getTime }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="total_money_wrap">
        <div class="total-money-list"><span class="total-money-title"><el-popover placement="top-start" content="任务金额与应付金额有误差一是合同是否含税，二是药企考核后会对应付金额有影响" trigger="hover">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>应付金额：</span><span class="total-money-num"> {{formData.invoiceAmount	 | numFmt | numDigit }}</span>元</div>
        <div class="total-money-list"><span class="total-money-title">服务费：</span><span class="total-money-num"> {{formData.serviceFee	 | numFmt | numDigit }}</span>元</div>
        <div class="total-money-list"><span class="total-money-title">任务金额：</span><span class="total-money-num"> {{formData.taskSumAmount  | numFmt | numDigit 	}}</span>元</div>
      </div>
      <!-- <div class="total-money-box">
        <div class="total-money-list"><span class="total-money-title">任务金额</span><span class="total-money-num">￥{{formData.taskSumAmount  | numFmt | numDigit 	}}</span></div>
        <div class="total-money-list"><span class="total-money-title">服务费</span><span class="total-money-num">￥{{formData.serviceFee	 | numFmt | numDigit }}</span></div>
        <div class="total-money-list"><span class="total-money-title"><el-popover placement="top-start" content="任务金额与应付金额有误差一是合同是否含税，二是药企考核后会对应付金额有影响" trigger="hover">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>应付金额</span><span class="total-money-num">￥{{formData.invoiceAmount	 | numFmt | numDigit }}</span></div>
      </div> -->
    </div>
    <!-- 开票说明 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票说明</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">是否邮寄：</span>
          <div class="contract-base-content">{{ formData.isMail == 'Y' ? '是' : '否' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">是否回款：</span>
          <div class="contract-base-content">{{ formData.isReceivePayment == 'Y' ? '是' : '否' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">发票类型：</span>
          <div class="contract-base-content">{{ formData.invoiceOptions | commonFilterName('发票选项') }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">药企名称：</span>
          <div class="contract-base-content">{{ formData.tenantName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">组织名称：</span>
          <div class="contract-base-content">{{ formData.organisationName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">开票日期：</span>
          <div class="contract-base-content">{{ formData.invoiceDate  | getDate }}</div>
        </el-col>
        <!-- <el-col :span="12">
          <span class="contract-base-title">发票类目：</span>
          <div class="contract-base-content">{{ formData.invoiceCategory | commonFilterName('发票类目') }}</div>
        </el-col> -->
        <el-col :span="12">
          <span class="contract-base-title">预计回款日期：</span>
          <div class="contract-base-content">{{ formData.planRepayDate | getDate}}</div>
        </el-col>
        <el-col :span="12" v-if="formData.isReceivePayment == 'Y'">
          <span class="contract-base-title">关联上游收款：</span>
          <div class="contract-base-content"><div v-for="(item,index) in formData.receivePaymentList" :key="index">{{item.receiveDate}}收款<span style="color:#ff5f1f;">{{item.receiveAmount  | numDigit}}</span>元</div></div>
        </el-col>
        <el-col :span="12" v-if="formData.isMail == 'Y'">
          <span class="contract-base-title">邮寄地址：</span>
          <div class="contract-base-content">{{ formData.mailAddress||'-' }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">简述或备注：</span>
          <div class="contract-base-content">
            <span style="color: red;">{{ formData.remarks }}</span><span>{{ formData.remarks ?'': '-' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 开票信息 -->
    <div class="contract-base-box">
      <p class="contract-base-name">开票信息</p>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">发票抬头：</span>
          <div class="contract-base-content">{{ formData.invoiceTenantName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">合计金额(元)：</span>
          <div class="contract-base-content">{{ formData.invoiceAmount | numDigit }}</div>
        </el-col>

        <div  v-for="(item, index) in formData.invoiceApplyDetailList" :key="index">
            <el-col :span="12">
              <span class="contract-base-title">发票类目{{index+1}}：</span>
              <div class="contract-base-content">{{ item.invoiceCategory | commonFilterName('发票类目')}}</div>
            </el-col>
            <el-col :span="12">
              <span class="contract-base-title">金额(元)：</span>
              <div class="contract-base-content">{{ item.invoiceAmount | numDigit }}</div>
            </el-col>
        </div>
        <div></div>
        <el-col :span="12">
          <span class="contract-base-title">开户银行：</span>
          <div class="contract-base-content">{{ formData.bankName }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">电话号码：</span>
          <div class="contract-base-content">{{ formData.contactTel || '-'}}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税号：</span>
          <div class="contract-base-content">{{ formData.taxpayerId || '-'}}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">银行账号：</span>
          <div class="contract-base-content">{{ formData.bankAccount || '-'}}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">单位地址：</span>
          <div class="contract-base-content">{{ formData.address || '-'}}</div>
        </el-col>
      </el-row>
    </div>
    <!-- 财务信息 已通过才展示-->
    <div class="contract-base-box" v-if="isShowFinanceInfo">
      <p class="contract-base-name">财务信息</p>
      <div class="contract-apply-file">
        <span class="file-label">票据附件信息：</span>
        <div>
          <div v-for="(item, index) in invoiceInfoVO.invoiceAttach" :key="index">
            <div class="contract-file-inform">
              <!-- <img
                width="32"
                height="32"
                class="mr10"
                :src="
                  item.type == 'word'
                    ? require('../../assets/images/word_icon.png')
                    : require('../../assets/images/pdf_icon.png')
                "
                alt=""
              /> -->
              <span> {{ item.fileName }}</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="toSee(item, index)">查看</span>
              <span class="fontC-4fa1a4 c-pointer ml10" @click="onDownload(item, index)">下载</span>

            </div>
          </div>
        </div>
      </div>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="contract-base-title">开票日期：</span>
          <div class="contract-base-content">{{ invoiceInfoVO.invoiceDate | getDate }}</div>
        </el-col>
        <el-col :span="12">
          <span class="contract-base-title">税率(%)：</span>
          <div class="contract-base-content">{{ invoiceInfoVO.taxRate | numDigit }}</div>
        </el-col>
        <el-col :span="12" v-if="invoiceInfoVO.logisticsInfoDTO?.expressNo">
          <span class="contract-base-title">快递单号：</span>
          <div class="contract-base-content">{{ invoiceInfoVO.logisticsInfoDTO.expressNo }}</div>
        </el-col>
        <el-col :span="12" v-if="invoiceInfoVO.logisticsInfoDTO?.expressCompany">
          <span class="contract-base-title">快递公司：</span>
          <div class="contract-base-content">
            {{ invoiceInfoVO.logisticsInfoDTO.expressCompany }}
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 流程 -->
    <div style="padding-left: 16px; background: #fff; margin-top: 4px">
      <iframe v-show="iframeSh" :src="srcs" class="iframe-sty"></iframe>
    </div>
    <!-- 提交 -->
    <div class="submit_btn_wrap" v-if="formData">
      <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
      <el-button type="borderRed" size="small" v-show="getBtnState('approval') == 'approval'" @click="toReject"
        >驳回</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('approval') == 'approval'" @click="toPass"
        >通过</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('again') == 'again'" @click="reSubmit"
        >重新提交</el-button
      >
      <el-button type="importNew" size="small" v-show="getBtnState('revoke') == 'revoke'" @click="toRevoke"
        >撤销</el-button
      >
    </div>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <PassDialog :flowType="flowType" @passSuccess="$router.go(-1)" ref="pass"></PassDialog>
  </div>
</template>
<script>
import { bpmnroute } from '@/api/apiRoute';
import Title from '@/components/title/title.vue';
import workFlowCommon from '@/uilt/workFlowCommon';
import PassDialog from './components/passDialog.vue';
import getTenantDetail from '../mixins/getTenantDetail';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
export default {
  components: {
    Title,
    PassDialog
  },
  mixins:[getTenantDetail],
  data() {
    return {
      flowType: '00018',
      rejectDialogVisible: false,
      passDialogVisible: false,
      qualityDialogVisible:false,
      fullscreenLoading:false,
      approveSuggest: '',//审批意见
      approveGuid:null,//审批ID
      formData: null,//页面数据
      tableData:[],//表格数据
      //流程
      srcs: '',//流程地址
      processInstanceId: '',//流程id
      iframeSh: true,//流程显示
      currentStaffGuid: null, //当前登录人guid
      fileList:[],
      invoiceInfoVO:null//财务信息
    };
  },
  async created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    await this.Mixins_getServiceProviderType();
    this.getPageDetail();
    this.getBpmnUrl();
  },
  methods: {
    //状态图片
    getApproveImg() {
      return workFlowCommon.getApproveImg(this.formData.approveVO && this.formData.approveVO.approveState);
    },
    //获取操作按钮显隐
    getBtnState(btnType) {
      let approveVO = this.formData && this.formData.approveVO;
      return workFlowCommon.getBtnState(
        btnType,
        approveVO.approveState,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        approveVO.staffGuid,
        this.formData.bizApproveState
      );
    },
    //查看附件
    toSee(file, index) {
      var fileSuffix = file.fileName ? file.fileName.substring(file.fileName.lastIndexOf('.') + 1) : '';
      if (fileSuffix === 'png' || fileSuffix === 'jpeg' || fileSuffix === 'jpg' || fileSuffix === 'pdf') {
        return window.open(file.path, file.fileName);
      }
      if (fileSuffix == 'zip' || fileSuffix == 'rar'||fileSuffix == 'tar') {
        return window.open(file.path + '?response-content-type=application/octet-stream');
      }
      if (fileSuffix=='ofd') {
        return window.open("https://ofd.xdocin.com/view?src=" + encodeURIComponent(file.path)); 
      }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file.path);
    },
    onDownload(file) {
      window.open(file.path + '?response-content-type=application/octet-stream');
    },
    //判断是否最后一个人审批
    isLastPerson(){
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid:userinfo.staffGuid,
        deploymentId:this.$route.query.camundaDeploymentId,
        processInstanceId:this.$route.query.camundaInstanceId
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let showPassForm = res.data.data || false;
          if(showPassForm == true){
            self.$refs.pass.showForm = showPassForm;
            self.$refs.pass.rowData = this.formData;
            self.$refs.pass.showPass = true;
          }else{
            self.passDialogVisible = true;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取详情
    getPageDetail() {
      let self = this;
      self.api.get(`/${serverConfig.msSalesPerformService}/upstream/payment-invoice-apply/detail?guid=${this.$route.query.guid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.formData = res.data.data;
          // self.formData.month = self.formData.month.substr(0,4) + '-' + self.formData.month.substr(4,2);
          self.formData.planRepayDate = self.$moment(self.formData.planRepayDate).format('YYYY-MM-DD');
          //当前审批id
          self.approveGuid = self.formData.approveVO && self.formData.approveVO.approveGuid;
          //财务信息
          self.invoiceInfoVO = self.formData.invoiceInfoVO;
          //财务文件处理
          if (self.invoiceInfoVO && self.invoiceInfoVO.paymentAdviceAttach) {
            self.invoiceInfoVO.paymentAdviceAttach.forEach((i) => {
              let fileSuffix = i.fileName ? i.fileName.substring(i.fileName.lastIndexOf('.') + 1) : '';
              if (fileSuffix == 'pdf' || fileSuffix == 'PDF') {
                i.type = 'pdf';
              } else if (fileSuffix == 'xls' || fileSuffix == 'xlsx') {
                i.type = 'excel';
              } else if (fileSuffix == 'zip' || fileSuffix == 'rar') {
                i.type = 'zip';
              } else if (fileSuffix == '.doc' || fileSuffix == '.docx') {
                i.type = 'word';
              } else {
                i.type = 'img';
              }
            });
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取流程地址
    getBpmnUrl() {
      if (this.$route.query.camundaInstanceId && this.$route.query.camundaDeploymentId) {
        this.srcs =
          bpmnroute +
          '/iframeBpmn?processInstanceId=' +
          this.$route.query.camundaInstanceId +
          '&camundaDeploymentId=' +
          this.$route.query.camundaDeploymentId +
          '&token=' +
          localStorage.token;
        console.log(this.srcs)
      } else {
        this.iframeSh = false;
      }
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.approveGuid,
            flowType: self.flowType,
            approveStaffGuid: self.currentStaffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              sessionStorage.refresh = 1;
              self.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    //重新提交
    reSubmit() {
      this.$router.push({
        path: '/upstreamInvoicingAdd',
        query: {
          // bizGuid: this.$route.query.bizGuid,
          guid: this.$route.query.guid,
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass() {
      let self = this;
      self.approveSuggest = '';
      if (self.isThirdPartyContractor) {
        self.passDialogVisible = true;
        return;
      }
      self.isLastPerson();
    },
    toReject() {
      let self = this;
      self.approveSuggest = '';
      self.rejectDialogVisible = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('审批通过！');
          sessionStorage.refresh = 1;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.approveGuid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid: self.currentStaffGuid,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('驳回成功！');
          sessionStorage.refresh = 1;
          self.rejectDialogVisible = false;
          self.$router.go(-1);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
  computed: {
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    // 是否展示财务信息
    isShowFinanceInfo() {
      if (this.isThirdPartyContractor) {
        // 三方不展示
        return false;
      }
      // 已通过才展示(原有逻辑)
      return this.formData.approveVO?.approveState == 'Y' && this.invoiceInfoVO
    },
  },
};
</script>
<style scoped>
.contract-information-page {
  overflow: auto;
}
.contract-base-box {
  position: relative;
  padding: 10px 16px;
  margin-top: 4px;
  background: #fff;
}
.contract-base-name {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin: 0 0 10px 0;
}
/* 申请信息 */
.contract-apply-box {
  display: flex;
  padding-left: 10px;
  margin-bottom: 25px;
}
.contract-apply-item {
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
  border-right: 1px solid #e5e5e5;
}
.contract-apply-file {
  display: flex;
  font-size: 14px;
  color: #666666;
  padding: 0 20px;
  box-sizing: border-box;
}
.contract-file-inform {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
}
.approve-img {
  position: absolute;
  top: 20%;
  right: 60px;
  width: 78px;
  height: 78px;
}
/* 页面信息 */
.contract-base-box .el-col-12 ,.contract-base-box .el-col-24{
  display: flex;
  line-height: 22px;
  margin-bottom: 10px;
}
.el-col-12:nth-child(2n + 1) .contract-base-title ,.el-col-24:nth-child(2n + 1) .contract-base-title{
  flex-shrink: 0;
  width: 100px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.el-col-12:nth-child(2n) .contract-base-title ,.el-col-12:nth-child(2n) .contract-base-title{
  flex-shrink: 0;
  width: 140px;
  text-align: right;
  font-size: 14px;
  color: #666666;
}
.contract-base-content {
  color: #212121;
  text-align: left;
}
/* 流程 */
.iframe-sty {
  width: 100%;
  height: 500px;
  border: none;
  /* background:grey; */
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-top: 1px solid #d9d9d9;
  background: #fff;
}
.duichong-img{
  position:absolute;
  top:0;
  right:0;
  width:81px;
}

</style>
